import { render, staticRenderFns } from "./DraftCurriculumList.vue?vue&type=template&id=7bb61295&scoped=true&lang=pug"
import script from "./DraftCurriculumList.vue?vue&type=script&lang=js"
export * from "./DraftCurriculumList.vue?vue&type=script&lang=js"
import style0 from "./DraftCurriculumList.vue?vue&type=style&index=0&id=7bb61295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb61295",
  null
  
)

export default component.exports